import React, { Component } from "react";
import DupontIconButton from "components/DupontIconButton";
import EditTableIcon from "assets/SvgIcon/Table/EditTableIcon";
import { valueStrings } from "constants/constantStrings";

export default class SystemEditRenderer extends Component {
  constructor(props) {
    super(props);
    this.invokeParentMethod = this.invokeParentMethod.bind(this);
  }

  invokeParentMethod() {
    this.props.context.handleEditClick(this.props.node.data);
  }

  render() {
    return (
      <DupontIconButton tooltip={valueStrings.edit} onClick={this.invokeParentMethod}>
        <EditTableIcon />
      </DupontIconButton>
    );
  }
}
